import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import I18n from 'I18n';
import { useMemo, useState } from 'react';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import UIProgress from 'UIComponents/progress/UIProgress';
import { getPlaylistAssignmentsUrl, PlaylistAssignmentsProgressContainer, useFilteredPlaylistAssignmentsPortals } from '..';
import { FormattedMessage } from '../../../components/I18n';
import { theme } from '../../../utils/Styling';
import { TABLE_PAGINATOR_SIZE, Table } from '../../table';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import { UsersAvatarList } from '../../avatar';
import formatName from 'I18n/utils/formatName';

const PlaylistAssignmentsPortalsTableHeader = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.columns.team"
      })
    }), /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.columns.domain"
      })
    }), /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.columns.members"
      })
    }), /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.columns.users"
      })
    })]
  });
};

const PlaylistAssignmentsPortalsTableHeaderActions = ({
  selectedRowsCount
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("small", {
      style: {
        textTransform: 'none',
        fontWeight: 400
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.playlistAssignments.portalsSelected`,
        options: {
          count: selectedRowsCount
        }
      })
    }), /*#__PURE__*/_jsxs(UIList, {
      childClassName: "m-left-3",
      inline: true,
      children: [/*#__PURE__*/_jsxs(UILink, {
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "add"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.common.assign"
        })]
      }), /*#__PURE__*/_jsxs(UILink, {
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "delete"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.common.unassignAll"
        })]
      })]
    })]
  });
};

const PlaylistAssignmentsPortalsTableRow = ({
  playlistId,
  portalId,
  portalName,
  portalDomain,
  assignees,
  progressPercentage
}) => {
  const url = getPlaylistAssignmentsUrl(playlistId, portalId);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsxs(PlaylistAssignmentsProgressContainer, {
        children: [/*#__PURE__*/_jsx(UIRouterLink, {
          to: url,
          children: portalName
        }), /*#__PURE__*/_jsx(UIProgress, {
          "aria-label": I18n.text('learningCenter.playlistAssignments.teamProgress'),
          use: "success",
          value: progressPercentage
        })]
      })
    }), /*#__PURE__*/_jsxs("td", {
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          fontWeight: 500
        },
        children: portalDomain
      }), /*#__PURE__*/_jsx("div", {
        style: {
          color: theme.colors.EERIE
        },
        children: portalId
      })]
    }), /*#__PURE__*/_jsx("td", {
      style: {
        fontWeight: 500
      },
      children: assignees.length
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(UsersAvatarList, {
        hasMoreHref: url,
        users: assignees.map(({
          firstName,
          lastName,
          userId
        }) => {
          return {
            displayName: formatName({
              firstName,
              lastName
            }),
            userId //avatarHash,

          };
        })
      })
    })]
  });
};

const PlaylistAssignmentsPortalsTable = ({
  playlistId
}) => {
  const [page, setPage] = useState(1);
  const {
    playlistAssignmentsPortals,
    pageCount
  } = useFilteredPlaylistAssignmentsPortals({
    playlistId,
    page
  });
  const rows = useMemo(() => {
    const portalsRecord = {};
    if (playlistAssignmentsPortals) playlistAssignmentsPortals.forEach(portal => {
      portalsRecord[portal.portalId] = portal;
    });
    return portalsRecord;
  }, [playlistAssignmentsPortals]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Table, {
      renderHeader: () => /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsTableHeader, {}),
      renderHeaderActions: selectedRowsCount => /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsTableHeaderActions, {
        selectedRowsCount: selectedRowsCount
      }),
      renderRow: data => /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsTableRow, Object.assign({}, data)),
      rows: rows
    }), pageCount > 1 && /*#__PURE__*/_jsx(UIPaginator, {
      maxVisiblePageButtons: TABLE_PAGINATOR_SIZE,
      onPageChange: ({
        target: {
          value
        }
      }) => setPage(value),
      page: page,
      pageCount: pageCount
    })]
  });
};

export default PlaylistAssignmentsPortalsTable;